import { RoleHost } from '../RoleHost';

export function QBWrapper() {
  return <RoleHost role="qb" />;
}
